var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 35.5,
    viewBox: "0 0 68 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio",
    transform: "translate(-709.5 -357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    "data-name": "Path 6792",
    d: "M3,15.639v7.222m8.125-5.417v3.611M19.25,8.417V30.083M27.375,3V35.5M35.5,15.639v7.222",
    transform: "translate(740.5 355.5)",
    fill: "none",
    stroke: "#0052cc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M3,15.639v7.222M11.125,8.417V30.083M19.25,3V35.5M27.375,8.417V30.083M35.5,15.639v7.222",
    transform: "translate(708 355.5)",
    fill: "none",
    stroke: "#0052cc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.8da8e850f41e58ae09eb9bc7340f1f83.svg";
export { ForwardRef as ReactComponent };